/* eslint-disable react/require-default-props */
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Logo } from './Logo';

const BrandWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const FooterLogoWrapper = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  width: 8rem;

  @media only screen and (min-width: 1024px) {
    width: 10rem;
  }
`;

const FooterLogoText = styled.div<{ light?: boolean }>`
  color: ${({ light }) => (light ? '#ffffff' : '#575757')};
  font-size: 10px;
  margin-bottom: 0.1rem;
`;

const CopyRightText = styled.a<{ light?: boolean }>`
  color: ${({ light }) => (light ? '#ffffff' : '#575757')};
  display: block;
  font-size: 10px;
  margin-top: 0.1rem;
  text-decoration: none;

  &:hover {
    color: ${({ light }) => (light ? '#ffffff' : '#575757')};
    text-decoration: none;
  }
`;

const LogoLink = styled.a`
  width: 100%;
`;

interface AnimatedTextProps {
  light?: boolean;
  hideCopyright?: boolean;
}

export const FooterLogo = ({
  hideCopyright,
  light,
}: AnimatedTextProps): ReactElement => (
  <BrandWrapper>
    <FooterLogoWrapper>
      <FooterLogoText light={light}>Powered By:</FooterLogoText>
      <LogoLink href="https://www.deckard.com" target="_blank" rel="noreferrer">
        <Logo />
      </LogoLink>
    </FooterLogoWrapper>

    {!hideCopyright && (
      <CopyRightText
        light={light}
        href="https://www.deckard.com"
        target="_blank"
        data-testid="copyrightlink"
        rel="noreferrer"
      >
        &copy;
        {new Date().getFullYear()}
        {' '}
        deckard.com
      </CopyRightText>
    )}
  </BrandWrapper>
);
